import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Pages/Login";
import Main from "./Main";
import ForgotPassword from "./Pages/ForgotPassword";
import Registration from "./Pages/Registration";
import RegisterCompany from "./Pages/RegisterCompany.jsx";
import InvoiceViewPage from "./Pages/InvoiceViewPage";
import CreditNotePage from "./Pages/CreditNotePage";
import QuotationViewPage from "./Pages/QuotationViewPage";
import DispatchViewPage from "./Pages/DispatchViewPage";
import PurDispatchViewPage from "./Pages/PurDispatchViewPage";
import PurInvoiceViewPage from "./Pages/PurInvoiceViewPage";
import PurOrderViewPage from "./Pages/PurOrderViewPage";

import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext.js";
import { RightsProvider } from "./context/RightsContext";
import { UserDefineProvider } from "./context/UserDefineContext";
import { ConfigureProvider } from "./context/ConfigureContext";
import LogoutTransition from "./components/LogoutTransition";

const APP_VERSION = "V1.26.10.24";

function App() {
  const connectionString = process.env.REACT_APP_CONNECTION_STRING;
  const pdfString = process.env.REACT_APP_PDF_STRING;

  console.log(pdfString);
  return (
    <AuthProvider connectionString={connectionString}>
      <UserDefineProvider connectionString={connectionString}>
      <ConfigureProvider connectionString={connectionString}>
      <RightsProvider connectionString={connectionString}>
      <NotificationProvider API={connectionString}>

        <Router>
          <LogoutTransition />
          <Routes>
            {/* Public Routes: No change */}
            <Route path="/" element={<Login connectionString={connectionString} />} />
            <Route path="/register" element={<Registration connectionString={connectionString} />} />
            <Route path="/forgot-password" element={<ForgotPassword connectionString={connectionString} />} />

            <Route path="/registerCompany" element={<RegisterCompany connectionString={connectionString} />} />

            {/* Protected Route: Now uses Context internally — no props needed */}
            <Route path="/main/*" element={<Main connectionString={connectionString} pdfString={pdfString} appVersion={APP_VERSION} />} />

            {/* Public view pages: Still pass connectionString (they don't need auth) */}
            <Route path="/invoice/:saleInvoiceId" element={<InvoiceViewPage connectionString={connectionString} />} />
            <Route path="/creditNote/:creditNoteId" element={<CreditNotePage connectionString={connectionString} />} />
            <Route path="/quotation/:quotationId" element={<QuotationViewPage connectionString={connectionString} />} />
            <Route path="/Dispatch-Order/:challanId" element={<DispatchViewPage connectionString={connectionString} />} />
            <Route path="/Purchase-Order/:quotationId" element={<PurOrderViewPage connectionString={connectionString} />} />
            <Route path="/Purchase-Dispatch-Order/:challanId" element={<PurDispatchViewPage connectionString={connectionString} />} />
            <Route path="/Purchase-Invoice/:saleInvoiceId" element={<PurInvoiceViewPage connectionString={connectionString} />} />

            {/* Redirect root */}
            <Route path="/" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>

      </NotificationProvider>
      </RightsProvider>
      </ConfigureProvider>
      </UserDefineProvider>
    </AuthProvider>
  );
}

export default App;